/**
 * User Roles Control Component
 * 
 * @package TopBuddy
 */

import { FormTokenField, BaseControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const UserRolesControl = ({ value, onChange, availableRoles, loginStatus }) => {
	// Only show if logged in users is selected.
	if (loginStatus !== 'logged_in') {
		return null;
	}

	// Convert role slugs to role names for display
	const selectedRoleNames = value.map(slug => availableRoles[slug] || slug);

	// Get all available role names for suggestions
	const allRoleNames = Object.values(availableRoles);

	// Handle token field changes
	const handleTokensChange = (tokens) => {
		// Convert role names back to slugs
		const roleSlugs = tokens.map(name => {
			// Find the slug that matches this name
			const entry = Object.entries(availableRoles).find(([slug, roleName]) => roleName === name);
			return entry ? entry[0] : name;
		});
		onChange(roleSlugs);
	};

	return (
		<div className="topbuddy-display-rules__field">
			<BaseControl
				label={__('User Roles', 'topbuddy')}
				help={__('Select which user roles can see this notification bar (leave empty for all roles)', 'topbuddy')}
				id="topbuddy-user-roles"
			>
				<FormTokenField
					value={selectedRoleNames}
					suggestions={allRoleNames}
					onChange={handleTokensChange}
					placeholder={__('Select user roles...', 'topbuddy')}
				/>
			</BaseControl>
		</div>
	);
};

export default UserRolesControl;
